import styled from "styled-components";
import PropTypes from "prop-types";
import { ReactComponent as CircleIcon } from "../resources/icons/circle-solid.svg";

function Badge({ variant = "primary", text, className }) {
  return (
    <StyledBadge className={className} variant={variant}>
      <CircleIcon fill="currentColor" className="mr-1" height=".6em" />
      {text}
    </StyledBadge>
  );
}
const StyledBadge = styled.span.attrs((props) => ({
  className: `badge badge-${props.variant ? props.variant : "primary"}`,
}))`
  & svg {
    vertical-align: baseline;
  }
`;

Badge.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
  ]),
};

export default Badge;
